import { ActionType } from '../constants/ActionTypes';
import { Constants } from '../constants/Constants';
import { RestPath } from '../constants/SitePaths'
import config from '../constants/Configs';
import axios from 'axios';

// Get All Players
export const getPlayersBegin = () => ({
    type: ActionType.GET_PLAYERS_BEGIN
});

export const getPlayersSuccess = (data) => ({
    type: ActionType.GET_PLAYERS_SUCCESS,
    payload: data
});

export const getPlayersError = (data) => ({
    type: ActionType.GET_PLAYERS_FAILURE,
    payload: data
});

// Top Up Players
export const topUpPlayerBegin = () => ({
    type: ActionType.TOPUP_PLAYER_BEGIN
});

export const topUpPlayerSuccess = (data) => ({
    type: ActionType.TOPUP_PLAYER_SUCCESS,
    payload: data
});

export const topUpPlayerError = (data) => ({
    type: ActionType.TOPUP_PLAYER_FAILURE,
    payload: data
});

export const getPlayerTopUpBegin = () => ({
    type: ActionType.GET_PLAYER_BALANCE_BEGIN
});


export const getPlayerTopUpSuccess = (data) => ({
    type: ActionType.GET_PLAYER_BALANCE_SUCCESS,
    payload: data
});

export const getPlayerTopUpError = (data) => ({
    type: ActionType.GET_PLAYER_BALANCE_FAILURE,
    payload: data
});

export function getPlayers(affiliateId, pageNumber, formData) {
    return dispatch => {
        dispatch(getPlayersBegin());

        let params = formData ? {
            affiliateId,
            pageNumber,
            email: formData.email,
            playerId: formData.playerId,
            registrationStartDate: formData.registrationStartDate,
            registrationEndDate: formData.registrationEndDate,
            lastLoginDate: formData.lastLoginDate,
            lastLoginEndDate: formData.lastLoginEndDate
        } : { affiliateId, pageNumber }
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_PLAYERS,
            params: params

        }).then((response) => {
            dispatch(getPlayersSuccess(response.data));

            return response.data;
        })
            .catch((error) => {
                dispatch(getPlayersError(error));
            });
    }
}

export function getPlayerTopUp(id) {
    return dispatch => {
        dispatch(getPlayerTopUpBegin());
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_PLAYER_BALANCE,
            params: {id}

        }).then((response) => {
            dispatch(getPlayerTopUpSuccess(response.data));

            return response.data;
        }).catch((error) => {
            dispatch(getPlayerTopUpError(error));
        });
    }
}

export function topUpPlayer(formData, affiliateId) {
    return dispatch => {
        dispatch(topUpPlayerBegin());

        let params = {
            affiliateId: affiliateId,
            playerId: formData.playerId,
            amount: formData.amount
        }

        return axios({
            method: Constants.PUT,
            url: config.BASE_URL + RestPath.TOPUP_PLAYER,
            data: params

        }).then((response) => {
            dispatch(topUpPlayerSuccess(response.data));

            return response.data;
        })
            .catch((error) => {
                dispatch(topUpPlayerError(error));
            });
    }
}



// WEBPACK FOOTER //
// ./src/actions/PlayersAction.js